import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const HdmiCable = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M4.02.758h7.958v5.415h.817v2.986l-1.847 3.3v2.123H9.24v1.904H6.758v-1.904H5.05v-2.124l-1.847-3.3V6.174h.817V.758Zm.667 5.415h1.225V1.424H4.687v4.749ZM6.58 1.424v2.062h.988v.667H6.58v2.02h2.84v-2.02h-.957v-.667h.957V1.424H6.58Zm3.507 0v4.749h1.225V1.424h-1.225ZM3.87 6.84v2.145l1.71 3.053h4.84l1.709-3.053V6.84h-8.26Zm1.847 5.865v1.21h4.564v-1.21H5.717Zm1.708 1.877v1.238h1.149v-1.238h-1.15Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

HdmiCable.category = 'product-category';

HdmiCable.displayName = 'HdmiCable';
